import { useState } from "react";
import EnhancedTable from "../utils/table-layouts/EnhancedTable";
import { DiscountedSalariesHeadCells } from "../../helpers/datasets/table-header-data";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import { DiscountedSalariesRows } from "helpers/datasets/table-rows";
import styled from "@emotion/styled";
import { IconAngleRight } from "assets/icons";

const useStyles = makeStyles((theme) => ({
  tableCell: {
    "&.MuiTableCell-root": {
      fontSize: "14px",
    },
  },
}));

const DiscountedSalariesTable = () => {
  const classes = useStyles();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  return (
    <EnhancedTable
      headCells={DiscountedSalariesHeadCells}
      rows={DiscountedSalariesRows}
      page={page}
      paginationLabel="Showing"
      hasCheckbox={false}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
    >
      {DiscountedSalariesRows
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {

          return (
            <TableRow hover tabIndex={-1} key={row.id}>
              <TableCell className={classes.tableCell}><input type="checkbox" /></TableCell>
              <TableCell className={classes.tableCell}>{row.date}</TableCell>
              <TableCell className={classes.tableCell}>{row.name}</TableCell>
              <TableCell className={classes.tableCell}>{row.memberId}</TableCell>
              <TableCell className={classes.tableCell}>{row.bank}</TableCell>
              <TableCell className={classes.tableCell}>{row.accountName}</TableCell>
              <TableCell className={classes.tableCell}>{row.accountNumber}</TableCell>
              <TableCell className={classes.tableCell}>{row.amount}</TableCell>
              <TableCell className={classes.tableCell}><GotoSign><IconAngleRight /></GotoSign></TableCell>
            </TableRow>
          );
        })}
    </EnhancedTable>
  );
};

export default DiscountedSalariesTable;

const GotoSign = styled.span`
  background: #F2F2F2;
  height: 15px;
  width: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;

  svg {
    stroke: #000;
    color: #000;
    transform: rotate(180deg);
  }
`